/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import "./Footer.css";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import PhoneIcon from "@mui/icons-material/Phone";
import TwitterIcon from "@mui/icons-material/Twitter";
import GoogleIcon from "@mui/icons-material/Google";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Link, useLocation } from "react-router-dom";
import Aos from "aos";
import "aos/dist/aos.css";
import EmailIcon from "@mui/icons-material/Email";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
/* Screen-reader-only helper */
const VisuallyHidden = ({ children }) => (
    <span style={{
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        width: '1px',
        whiteSpace: 'nowrap'
    }}>{children}</span>
);

function Footer() {
    const location = useLocation();
    useEffect(() => {
        Aos.init(
            {
                once: false,
                offset: 100,
                duration: 400,
                mirror: false,
            },
            []
        );
    });

    const exeRoutes = [
        "/website-development",
        "/mobile-app-development-company",
        "/ERP-implementation-services",
        "/outsourcing-web-development",
        "/web-design-development",
    ];

    const exeForConstactss = [
        "/web-design-development",
        "/outsourcing-web-development",
        "/ERP-implementation-services",
        "/website-development",
        "/mobile-app-development-company",
    ];

    const isExcludedPath = (path) => exeRoutes.includes(path);
    const isNonClickable = isExcludedPath(location.pathname);

    const showNavbarContactDetails = exeForConstactss.includes(location.pathname);

    return (
        <>
            <div className="footer">
                <div className="row5" data-aos="fade-up" data-aos-duration="1000">
                    {location.pathname === "/ERP-implementation-services" || location.pathname === "/website-development" || location.pathname === "/web-development-company" ? (
                        <> <h4>Solutions</h4>
                            <span>Inventory</span>
                            <span>Production</span>
                            <span>Sales & Purchase</span>
                            <span>Quality</span>
                            <span>Accounting</span>
                            <span>Procurement</span>
                        </>
                    ) : (
                        <>
                            <h4>Technologies</h4>
                            <span>React</span>
                            <span>Angular</span>
                            <span>Devops</span>
                            <span>Java</span>
                            <span>SQL Services</span>
                            <span>MongoDB</span>
                            <span>Python</span>
                            <span>Spring</span>
                            <span>JPA</span>
                        </>
                    )}

                </div>
                <div className="row2" data-aos="fade-up" data-aos-duration="1000">

                    {location.pathname === "/ERP-implementation-services" || location.pathname === "/website-development" || location.pathname === "/web-development-company" ? (
                        <><h4>Our Services</h4>
                            <span className="non-interactive">ERP Implementation</span>
                            <span className="non-interactive">HRM Implementation</span>
                            <span className="non-interactive">CRM Implementation</span>
                            <span className="non-interactive">DMS Implementation</span>
                            <span className="non-interactive">SFA Implementation</span>
                            <span className="non-interactive">Web Application</span>
                            <span className="non-interactive">Mobile Application</span>
                            <span className="non-interactive">High Performance Website Designing</span>
                            <span className="non-interactive">Third Party Outsourcing</span>
                            <span className="non-interactive">IT Consultancy</span>
                        </>
                    ) : (
                        <>
                            <h4>Our Services</h4>
                            <Link to="/websitedevelopment">
                                <span>Web Application</span>
                            </Link>
                            <Link to="/mobileapp-development-company">
                                <span>Mobile Application</span>
                            </Link>
                            <Link to="/web-design-development">
                                <span>High Performance Website Designing</span>
                            </Link>
                            <Link to="/outsourcingweb-development">
                                <span>Third Party Outsourcing</span>
                            </Link>
                            <Link to="/ERPimplementation-services">
                                <span>ERP Implementation</span>
                            </Link>
                            <Link to="/hrms-implement">
                                <span>HRMS</span>
                            </Link>
                            <Link to="/dms">
                                <span>DMS Implementation</span>
                            </Link>
                            <Link to="/sfa">
                                <span>SFA Implementation</span>
                            </Link>
                            <Link to="/services">
                                <span>IT Consultancy</span>
                            </Link>
                        </>
                    )}
                </div>

                <div className="row3" data-aos="fade-up" data-aos-duration="1000">
                    <h4>Company</h4>
                    {location.pathname === "/ERP-implementation-services" || location.pathname === "/website-development" || location.pathname === "/web-development-company" ? (
                        <>
                            <span className="non-interactive ">Home</span>
                            <span className="non-interactive">Industries</span>
                            <span className="non-interactive">Solutions</span>
                            <span className="non-interactive">Pricing</span>
                        </>
                    ) : (
                        <>
                            <Link to="/about">
                                <span>About Us</span>
                            </Link>
                            <Link to="/technologies">
                                <span>Technology</span>
                            </Link>
                            <Link to="/blog">
                                <span>Consulting</span>
                            </Link>
                            <Link to="/career">
                                <span>Clients</span>
                            </Link>
                            <Link to="/contact">
                                <span>Contact</span>
                            </Link>
                        </>
                    )}
                </div>
                <div className="row4" data-aos="fade-up" data-aos-duration="1000">
                    <h4>TechCognics India Pvt.Ltd</h4>
                    <span>Office No. 1010 & 1011, 10th Floor,</span>
                    <span>Gera’s Imperium Alpha, Kharadi, Pune</span>
                    <span>Maharashtra - 411014 </span>
                    <span className="d-flex align-items-center">

                        <a
                            href="tel:+919890452720"
                            className="me-2"
                            aria-label="Call TechCognics at +91 9890452720"
                        >
                            <PhoneIcon
                                fontSize="medium"
                                className="grow"
                                aria-hidden="true"
                                style={{
                                    background: "#2b87c7",
                                    borderRadius: "50%",
                                    color: "#fff",
                                    padding: "6px",
                                }}
                            />
                            <VisuallyHidden>Call TechCognics at +91 9890452720</VisuallyHidden>
                        </a>


                        <span>+91 9890452720</span>
                    </span>
                    <span className="d-flex align-items-center">
                        <a
                            href="mailto:sales@techcognicsindia.com"
                            className="me-2"
                            aria-label="Email TechCognics at sales@techcognicsindia.com"
                        >
                            <EmailIcon
                                fontSize="medium"
                                className="grow"
                                aria-hidden="true"
                                style={{
                                    background: "#2b87c7",
                                    borderRadius: "50%",
                                    color: "#fff",
                                    padding: "6px",
                                }}
                            />
                            <VisuallyHidden>Email TechCognics at sales@techcognicsindia.com</VisuallyHidden>
                        </a>

                        <span>sales@techcognicsindia.com</span>
                    </span>
                    {!showNavbarContactDetails && (
                        <>
                            <span>
                                <a
                                    href="tel:+919890452720"
                                    target="_blank"
                                    className="option_link hover:text-cyan-300"
                                    rel="noreferrer"
                                    aria-label="Call TechCognics at +91 9890452720"
                                >
                                    <VisuallyHidden>Call TechCognics at +91 9890452720</VisuallyHidden>
                                </a>
                            </span>

                        </>
                    )}

                    <div className="handles" data-aos="flip-up" data-aos-duration="1000">
                        <h5>Follow Us</h5>
                        <div className="handle">

                            {/* Facebook */}
                            <a
                                href="https://www.facebook.com/profile.php?id=61565725310930"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Facebook"
                            >
                                <FacebookRoundedIcon
                                    fontSize="medium"
                                    className="grow"
                                    aria-hidden="true"
                                    style={{
                                        background: "#1877F2",
                                        borderRadius: "50%",
                                        color: "#fff",
                                        marginRight: "8px",
                                    }}
                                />
                                <VisuallyHidden>Follow TechCognics on Facebook</VisuallyHidden>
                            </a>

                            {/* Instagram */}
                            <a
                                href="https://www.instagram.com/techcognicsindia/"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Instagram"
                            >
                                <InstagramIcon
                                    fontSize="medium"
                                    className="grow"
                                    aria-hidden="true"
                                    style={{
                                        background: "linear-gradient(45deg,#F58529,#DD2A7B,#8134AF,#515BD4)",
                                        borderRadius: "50%",
                                        color: "#fff",
                                        marginRight: "8px",
                                    }}
                                />
                                <VisuallyHidden>Follow TechCognics on Instagram</VisuallyHidden>
                            </a>

                            {/* Twitter / X */}
                            <a
                                href="https://x.com/TechCognicsInd"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Twitter X"
                            >
                                <TwitterIcon
                                    fontSize="medium"
                                    className="grow"
                                    aria-hidden="true"
                                    style={{
                                        background: "#000",
                                        borderRadius: "50%",
                                        color: "#fff",
                                        marginRight: "8px",
                                    }}
                                />
                                <VisuallyHidden>Follow TechCognics on Twitter</VisuallyHidden>
                            </a>

                            {/* Email */}
                            <a
                                href="mailto:sales@techcognicsindia.com"
                                aria-label="Email TechCognics"
                            >
                                <GoogleIcon
                                    fontSize="medium"
                                    className="grow"
                                    aria-hidden="true"
                                    style={{
                                        background: "#dc6218",
                                        borderRadius: "50%",
                                        color: "#fff",
                                        marginRight: "8px",
                                    }}
                                />
                                <VisuallyHidden>Email TechCognics</VisuallyHidden>
                            </a>

                            {/* LinkedIn */}
                            <a
                                href="https://www.linkedin.com/company/techcognics-pvt-ltd"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="LinkedIn"
                            >
                                <LinkedInIcon
                                    fontSize="medium"
                                    className="grow"
                                    aria-hidden="true"
                                    style={{
                                        background: "#0A66C2",
                                        borderRadius: "50%",
                                        color: "#fff",
                                        marginRight: "8px",
                                    }}
                                />
                                <VisuallyHidden>Follow TechCognics on LinkedIn</VisuallyHidden>
                            </a>

                            {/* YouTube */}
                            <a
                                href="https://www.youtube.com/@TechCognics"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="YouTube"
                            >
                                <YouTubeIcon
                                    fontSize="medium"
                                    className="grow"
                                    aria-hidden="true"
                                    style={{
                                        background: "#FF0000",
                                        borderRadius: "50%",
                                        color: "#fff",
                                        marginRight: "8px",
                                    }}
                                />
                                <VisuallyHidden>Subscribe to TechCognics on YouTube</VisuallyHidden>
                            </a>

                        </div>

                    </div>
                </div>
            </div>

            <div className="footer_bottom">
                <div className="first_half">
                    Copyright © 2023{" "}
                    {window.location.pathname === "/ERP-implementation-services" ? (
                        <span className="hover:text-cyan-200" style={{ cursor: "default", color: "inherit" }}>
                            techcognicsindia.com
                        </span>
                    ) : (
                        <a
                            href="https://techcognicsindia.com/"
                            className="hover:text-cyan-200"
                        >
                            techcognicsindia.com
                        </a>
                    )}
                    - All rights reserved.
                </div>

                <div className="second_half">
                    <Link to="/privacy-policy" as={Link}>
                        <span className="hover:text-cyan-200">Terms and Conditions</span>
                    </Link>
                    |
                    <Link to="/privacy-policy" as={Link}>
                        <span className="hover:text-cyan-200">Privacy Policy</span>
                    </Link>
                    |<Link to="/contact">
                        <span className="hover:text-cyan-200">Site Map</span></Link>
                </div>
            </div>
        </>
    );
}

export default Footer;
